var map = {
	"./auth.js": "c7d4",
	"./axiosCancel.js": "3a9c",
	"./dates.js": "f6e5",
	"./lang.js": "bbe9",
	"./markets.js": "a969",
	"./periods.js": "14f2",
	"./regions.js": "af0e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6c17";